import React from 'react';
import { MessageCircle, AlertCircle, CheckCircle2 } from 'lucide-react';
interface Scenario {
  situation: string;
  question: string;
  withoutSystem: {
    title: string;
    outcome: string;
    cost: string;
  };
  withSystem: {
    title: string;
    outcome: string;
    benefit: string;
  };
}
interface InteractiveScenarioSlideProps {
  content: {
    scenario: Scenario;
    emoji: string;
  };
}
export function InteractiveScenarioSlide({
  content
}: InteractiveScenarioSlideProps) {
  const {
    scenario,
    emoji
  } = content;
  return <div className="bg-[#F5F5F5] rounded-2xl p-12" data-id="element-145">
      <div className="text-center mb-8" data-id="element-146">
        <div className="text-7xl mb-4" data-id="element-147">{emoji}</div>
        <h2 className="text-4xl font-bold text-[#1C1C1C] mb-4" data-id="element-148">
          Interactive Scenario
        </h2>
        <div className="flex items-center justify-center gap-2 text-[#0FB07D]" data-id="element-149">
          <MessageCircle size={20} data-id="element-150" />
          <span className="text-lg font-medium" data-id="element-151">
            Drop your answer in the chat!
          </span>
        </div>
      </div>

      {/* The Situation */}
      <div className="bg-white rounded-xl p-8 mb-8 border-l-4 border-[#0FB07D]" data-id="element-152">
        <h3 className="text-2xl font-bold text-[#1C1C1C] mb-4" data-id="element-153">
          The Situation:
        </h3>
        <p className="text-xl text-[#4D4D4D] leading-relaxed" data-id="element-154">
          {scenario.situation}
        </p>
      </div>

      {/* The Question */}
      <div className="bg-gradient-to-r from-[#017C6D] to-[#0FB07D] rounded-xl p-8 mb-8" data-id="element-155">
        <h3 className="text-2xl font-bold text-white mb-4" data-id="element-156">
          What Would You Do?
        </h3>
        <p className="text-xl text-white leading-relaxed" data-id="element-157">
          {scenario.question}
        </p>
      </div>

      {/* Two Outcomes */}
      <div className="grid grid-cols-2 gap-6" data-id="element-158">
        {/* Without System */}
        <div className="bg-white rounded-xl p-6 border-2 border-red-200" data-id="element-159">
          <div className="flex items-center gap-3 mb-4" data-id="element-160">
            <AlertCircle className="text-red-500" size={32} data-id="element-161" />
            <h4 className="text-xl font-bold text-[#1C1C1C]" data-id="element-162">
              {scenario.withoutSystem.title}
            </h4>
          </div>
          <p className="text-[#4D4D4D] mb-4 leading-relaxed" data-id="element-163">
            {scenario.withoutSystem.outcome}
          </p>
          <div className="text-2xl font-bold text-red-500" data-id="element-164">
            {scenario.withoutSystem.cost}
          </div>
        </div>

        {/* With System */}
        <div className="bg-white rounded-xl p-6 border-2 border-[#0FB07D]" data-id="element-165">
          <div className="flex items-center gap-3 mb-4" data-id="element-166">
            <CheckCircle2 className="text-[#0FB07D]" size={32} data-id="element-167" />
            <h4 className="text-xl font-bold text-[#1C1C1C]" data-id="element-168">
              {scenario.withSystem.title}
            </h4>
          </div>
          <p className="text-[#4D4D4D] mb-4 leading-relaxed" data-id="element-169">
            {scenario.withSystem.outcome}
          </p>
          <div className="text-2xl font-bold text-[#0FB07D]" data-id="element-170">
            {scenario.withSystem.benefit}
          </div>
        </div>
      </div>
    </div>;
}
export default InteractiveScenarioSlide;